<template>
<div class="userinfoshow">
    <user-title :msg="msg" />
    <user-index-collection-info :itemright="itemright" ref="goodslist" @editgoods="editgoods" :pagesize="20" :description="description" :emptyimg="emptyimg"/>
</div>
  
</template>

<script>
import UserCollectionInfo from './UserCollectionInfo.vue'
import UserIndexCollectionInfo from './UserIndexCollectionInfo.vue'
import UserTitle from './UserTitle.vue'
export default {
  data(){
    return{
      msg:"我的收藏",
      description:"您还没有收藏商品",   
      emptyimg:"/static/404/shoucang.png",
      itemright:"14px"
    }
  },
  components: {UserTitle, UserCollectionInfo,UserIndexCollectionInfo },
  methods:{
     editgoods(goodsid){
           this.$refs.goodslist.deletegoods(goodsid);

      },
  }

}
</script>

<style scoped>
.userinfotitle{
    color:#2655ae;
    font-size:18px;
    padding-bottom: 22px;
    border-bottom: 1px solid #fdd889;
    margin-bottom: 14px;
}

</style>


// WEBPACK FOOTER //
// src/components/user/UserCollection.vue